import assistanceImage from 'assets/images/assistance.svg';
import cx from 'classnames';
import { OpenSupportCaseButton } from 'components/OpenSupportCase';
import { Heading } from 'components/Typography';
import { useTranslation } from 'react-i18next';

export type Props = {
  className?: string;
};

export const SupportHelpCard = ({ className }: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div
      data-testid="index-help-card"
      className={cx(className, 'flex flex-col relative font-semibold bg-yellow-300 rounded-md h-[448px]')}
    >
      <div className="p-32 pb-0 md:p-40 md:pb-0 shrink-0">
        <Heading level="h4" className="mb-16">
          {t('support.helpCard.heading')}
        </Heading>

        <Heading level="h7" className="mb-16">
          {t('helpCard.description1')}
        </Heading>

        <OpenSupportCaseButton className="mb-16" />
      </div>

      <div className="h-full flex flex-col justify-end items-center overflow-hidden relative">
        <img
          alt=""
          className="block h-auto w-[75%] sm:w-full md:w-[75%] max-h-full absolute"
          srcSet={`${assistanceImage} 2x, ${assistanceImage} 1x`}
        />
      </div>
    </div>
  );
};
